// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
//  apiUrl: 'http://192.168.1.35:3009/',
//  apiUrl: 'http://localhost:3009/',
//  apiUrl: 'https://angular.handypro.com/',
//  apiUrl: 'https://beta.handypro.com/',
 apiUrl: 'https://staging-api.handypro.com/',
//  apiUrl: 'http://localhost:3009/',
//    apiUrl: 'https://angular.handypro.com/'
//   apiUrl : 'http://192.168.1.242:3009/',
  mapAPIKey: 'AIzaSyCT4284k2MyTwCb5LuG0BKy7k8S7Cs_A34',
  // apiUrl : 'https://book.handypro.com/'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
